import { apiClient } from "./client";
import { TipoDispositivo } from "../types";

// "misure" NON è più un tipo di documento: ora sono i sei campi numerici sotto.
export type DocumentoTipo = "scheda_tecnica" | "disegno" | "foto" | "manuale" | "video";

export interface DispositivoDocumento {
  id: string;
  dispositivo_id: string;
  tipo: DocumentoTipo;
  file_url: string;
  nome_file: string | null;
  mime_type: string | null;
  created_at: string;
}

/**
 * Le sei misure (cm). Prisma serializza i Decimal come stringa nel JSON, quindi
 * arrivano come `string` (es. "60.0"), non come number.
 */
export interface MisureDispositivo {
  misure_cassaforte_lunghezza: string | null;
  misure_cassaforte_profondita: string | null;
  misure_cassaforte_altezza: string | null;
  misure_ingombro_lunghezza: string | null;
  misure_ingombro_profondita: string | null;
  misure_ingombro_altezza: string | null;
}

export type MisurePayload = Partial<Record<keyof MisureDispositivo, number | null>>;

export interface DispositivoCatalogo extends MisureDispositivo {
  id: string;
  tipo_dispositivo: TipoDispositivo;
  marca: string;
  modello: string;
  sigla: string | null;
  descrizione: string | null;
  documenti: DispositivoDocumento[];
}

export async function listCatalogo(tipoDispositivo?: TipoDispositivo): Promise<{ dispositivi: DispositivoCatalogo[] }> {
  const { data } = await apiClient.get<{ dispositivi: DispositivoCatalogo[] }>("/catalogo", {
    params: tipoDispositivo ? { tipo_dispositivo: tipoDispositivo } : undefined,
  });
  return data;
}

export async function getDispositivo(id: string): Promise<{ dispositivo: DispositivoCatalogo }> {
  const { data } = await apiClient.get<{ dispositivo: DispositivoCatalogo }>(`/catalogo/${id}`);
  return data;
}

export async function createDispositivo(
  payload: {
    tipo_dispositivo: TipoDispositivo;
    marca: string;
    modello: string;
    sigla?: string;
    descrizione?: string;
  } & MisurePayload
): Promise<{ dispositivo: DispositivoCatalogo }> {
  const { data } = await apiClient.post<{ dispositivo: DispositivoCatalogo }>("/catalogo", payload);
  return data;
}

export async function updateDispositivo(
  id: string,
  payload: Partial<{ tipo_dispositivo: TipoDispositivo; marca: string; modello: string; sigla: string; descrizione: string }> &
    MisurePayload
): Promise<{ dispositivo: DispositivoCatalogo }> {
  const { data } = await apiClient.patch<{ dispositivo: DispositivoCatalogo }>(`/catalogo/${id}`, payload);
  return data;
}

export async function deleteDispositivo(id: string): Promise<{ success: true }> {
  const { data } = await apiClient.delete<{ success: true }>(`/catalogo/${id}`);
  return data;
}

export async function uploadDocumento(
  dispositivoId: string,
  tipo: DocumentoTipo,
  file: File
): Promise<{ documento: DispositivoDocumento }> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("tipo", tipo);
  const { data } = await apiClient.post<{ documento: DispositivoDocumento }>(
    `/catalogo/${dispositivoId}/documenti`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

export async function deleteDocumento(docId: string): Promise<{ success: true }> {
  const { data } = await apiClient.delete<{ success: true }>(`/catalogo/documenti/${docId}`);
  return data;
}
